var exports = {
  "u": "xe533113f--cbe2a7--filters",
};

module.exports = exports;
